import styled from 'styled-components';

const Excerpt = styled.div`
  margin-bottom: ${props => props.theme.paddings.pd}px;
`;

export default Excerpt;
